"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * WordPress dependencies
 */
var React = require("react");
var components_1 = require("@wordpress/components");
var globals_1 = require("@/globals");
var SelectDialog = /** @class */ (function (_super) {
    __extends(SelectDialog, _super);
    function SelectDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handlePostMessage = function (event) {
            if (event.origin === globals_1.baseUrl && event.data.type === 'cog-form-selected') {
                _this.props.onSelectForm(event.data);
                _this.props.setOpen(false);
            }
        };
        return _this;
    }
    SelectDialog.prototype.componentDidMount = function () {
        window.addEventListener('message', this.handlePostMessage, false);
    };
    SelectDialog.prototype.componentWillUnmount = function () {
        window.removeEventListener('message', this.handlePostMessage);
    };
    SelectDialog.prototype.render = function () {
        var _this = this;
        return (React.createElement(components_1.Modal, { title: "Cognito Forms", className: "cognito-modal", onRequestClose: function () { return _this.props.setOpen(false); }, shouldCloseOnClickOutside: false },
            React.createElement("iframe", { style: { width: '500px', height: '100%', display: 'block' }, src: "".concat(globals_1.baseUrl, "/integrations/cms"), title: "Choose a Form" })));
    };
    return SelectDialog;
}(React.Component));
exports.default = SelectDialog;
